import Vue from 'vue'
import { API_URL } from '../../api'
import ClustersFilter from '../../filters/ClustersFilter';
const state = {
    clusterCreate: {
        createdCluster: null,
        creatingCluster: false,
        createClusterStatus: null
    },
    clusterUpdate: {
        updatedCluster: null,
        updatingCluster: false,
        updateClusterStatus: null
    },
    clusterDelete: {
        deletingCluster: false,
        deleteClusterStatus: null
    },
    clusterSearch: {
        clustersCount: null,
        clusters: [],
        clustersPaginated: [],
        searchingClusters: false,
        searchClusterStatus: null
    },
}
const mutations = {
    ['SET_CLUSTER_CREATE'](state, change) {
        state.clusterCreate = { ...state.clusterCreate, ...change };
    },
    ['SET_CLUSTER_UPDATE'](state, change) {
        state.clusterUpdate = { ...state.clusterUpdate, ...change };
    },
    ['SET_CLUSTER_DELETE'](state, change) {
        state.clusterDelete = { ...state.clusterDelete, ...change };
    },
    ['SET_CLUSTER_SEARCH'](state, change) {
        state.clusterSearch = { ...state.clusterSearch, ...change };
    }
}
const actions = {
    createCluster: ({ commit }, payload) => {
        commit('SET_CLUSTER_CREATE', { createClusterStatus: null, createdCluster: null, creatingCluster: true })
        return Vue.http.post(API_URL + '/clusters/create', payload).then(response => {
            commit('SET_CLUSTER_CREATE', { createClusterStatus: 'success', createdCluster: response.body.results.cluster });
        }).catch(response => {
            commit('SET_CLUSTER_CREATE', { createClusterStatus: 'failed' });
        }).finally(() => {
            commit('SET_CLUSTER_CREATE', { creatingCluster: false });
        });
    },
    updateCluster: ({ commit }, payload) => {
        commit('SET_CLUSTER_UPDATE', { updateClusterStatus: null, updatedCluster: null, updatingCluster: true })
        return Vue.http.post(API_URL + '/clusters/update/' + payload.id, payload)
            .then(response => {
                commit('SET_CLUSTER_UPDATE', { updateClusterStatus: 'success', updatedCluster: response.body.results.cluster });
            })
            .catch(response => {
                commit('SET_CLUSTER_UPDATE', { updateClusterStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_CLUSTER_UPDATE', { updatingCluster: false });
            })
    },
    deleteCluster: ({ commit }, id) => {
        commit('SET_CLUSTER_DELETE', { deleteClusterStatus: null, deletedCluster: null, deletingCluster: true })
        return Vue.http.delete(API_URL + '/clusters/delete/' + id).then(response => {
            commit('SET_CLUSTER_DELETE', { deleteClusterStatus: 'success' });
        }).catch(response => {
            commit('SET_CLUSTER_DELETE', { deleteClusterStatus: 'failed' });
        }).finally(() => {
            commit('SET_CLUSTER_DELETE', { deletingCluster: false });
        })
    },
    searchClusters: ({ commit }, payload = { filter: ClustersFilter(), resultMode: 'default' }) => {
        commit('SET_CLUSTER_SEARCH', { searchClusterStatus: null, searchingClusters: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/clusters' + params).then(response => {
            if (payload.resultMode == 1) {
                commit('SET_CLUSTER_SEARCH', { searchClusterStatus: 'success', clustersCount: response.body.results.clusters });

            } else if (payload.resultMode == 2) {
                commit('SET_CLUSTER_SEARCH', { searchClusterStatus: 'success', clustersPaginated: response.body.results.clusters });

            } else {
                commit('SET_CLUSTER_SEARCH', { searchClusterStatus: 'success', clusters: response.body.results.clusters });
            }
        }).catch(response => {
            commit('SET_CLUSTER_SEARCH', { searchClusterStatus: 'failed' });
        }).finally(() => {
            commit('SET_CLUSTER_SEARCH', { searchingClusters: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/clusterStore.js